import { render, staticRenderFns } from "./MemberBaseForm.vue?vue&type=template&id=624f4432&"
import script from "./MemberBaseForm.vue?vue&type=script&lang=js&"
export * from "./MemberBaseForm.vue?vue&type=script&lang=js&"
import style0 from "./MemberBaseForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports